import { render, staticRenderFns } from "./MatchEditPopup.vue?vue&type=template&id=730d2b03&scoped=true"
import script from "./MatchEditPopup.vue?vue&type=script&lang=js"
export * from "./MatchEditPopup.vue?vue&type=script&lang=js"
import style0 from "./MatchEditPopup.vue?vue&type=style&index=0&id=730d2b03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d2b03",
  null
  
)

export default component.exports